export default __webpack_public_path__ + "static/media/filtro-button-mobile.76b24371.svg";